import { useTranslation } from 'react-i18next';
import logoImage from '../assets/acts-full-logo.svg';
import LanguageSwitcher from '../components/LanguageSwitcher';

const Confirmation = () => {
  const { t } = useTranslation();

  return (
    <div className={`md:!bg-blue-200`}>
      <div
        className={`flex h-screen flex-col items-center justify-center overflow-auto`}
      >
        <div className='w-full max-w-md bg-white p-6 md:shadow-md md:rounded-lg'>
          <img
            src={logoImage}
            alt='Acts Camp Logo'
            className='w-full h-35 md:h-40'
          />
          <div className='flex justify-between items-center align-middle pt-2 pb-4'>
            <div />
            <h2 className='text-2xl font-bold text-center'>
              {t('confirmation.title')}
            </h2>
            <div className='flex justify-end'>
              <LanguageSwitcher />
            </div>
          </div>
          
          <div className='space-y-4 py-4 text-left'>
            <div className='font-bold text-gray-900'>
              {t('confirmation.subject')}
            </div>
            
            <div className='text-gray-900'>
              {t('confirmation.greeting')}
            </div>

            <div className='space-y-4'>
              {t('confirmation.description')
                .split('\n')
                .map((line, index) => (
                  <p key={index} className='text-gray-600'>
                    {line}
                  </p>
                ))}
            </div>

            <p className='text-gray-600'>
              {t('confirmation.closing')}
            </p>

            <div className='pt-4 text-gray-900 whitespace-pre-line'>
              {t('confirmation.signature')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
